import PanelForm from './../panel/Form'
import React, {useEffect, useState} from "react";
import {AppApi} from "../AppApi";
import styles from './Form.module.css';

function Form() {

    const [images, setImages] = useState();

    function getImages() {
        AppApi.pub.getImpressum()
            .then(response => {
                setImages(response.data)
            })
            .catch(console.log)
    }

    useEffect(() => {
        if(images == null){
            getImages()
        }
    }, [images]);

    return (
      <div className="wrapper">
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <PanelForm>



          </PanelForm>

          {images?.map(image => (
              <img src={"data:image/png;base64, " + image} className={styles.root}/>
          ))}
      </div>
    );
}

export default Form;
